class CollectionFilter extends HTMLElement {
    constructor() {
        super();

        this.grid = document.querySelector('.js-collection-filter-grid');
        this.filterDesktop = document.querySelector('#FilterDesktop');
        this.counters = document.querySelectorAll('.js-collection-filter-counter');

        this.filterPopupButton = document.querySelector('.js-collection-filter-popup-button');
        this.boxes = document.querySelectorAll('.js-collection-filter-box');
        this.sticky = document.querySelector('.js-collection-filter-sticky');

        this.form = this.querySelector('form');
        this.accordion = this.querySelector('.js-collection-grid-accordion');
        this.range = this.querySelector('.js-collection-range');
        this.rangeMin = this.querySelector('.js-collection-filter-price-range-min');
        this.rangeMax = this.querySelector('.js-collection-filter-price-range-max');
        this.inputs = this.querySelectorAll('.js-collection-filter-input');

        this.classes = {
            loadWrapper : "collection-grid__wrapper--load"
        }

        this.initRange();

        this.inputs.forEach(input => {
            input.addEventListener('change', this.inputChange.bind(this));
        });

        this.initSticky();
        this.initDropdowns();
        initResetButtons();

        if (this.accordion) {
            this.accordion.querySelectorAll('.collection-grid__filter-box-title').forEach(item => {
                item.addEventListener('click', this.onAccordionItemClick.bind(this))
            });
        }
    }

    initSticky() {
        new Sticky('.js-collection-filter-sticky')
    }

    onAccordionItemClick(event) {
        const titleElement = event.currentTarget;
        const filterBox = titleElement.closest('.collection-grid__filter-box');
        const content = filterBox.querySelector('.collection-grid__filter-box-content');

        const isOpen = titleElement.classList.contains('collection-grid__filter-box-title--open');

        if (isOpen) {
            titleElement.classList.remove('collection-grid__filter-box-title--open');
            content.style.height = '0';
        } else {
            titleElement.classList.add('collection-grid__filter-box-title--open');
            content.style.height = `${content.scrollHeight}px`;
        }
    }

    initDropdowns() {
        const dropdowns = document.querySelectorAll('.collection-grid__form .collection-grid__filter-box');

        const handleDropdownClick = (event) => {
            event.stopPropagation();

            const clickedDropdown = event.target.closest('.collection-grid__filter-box');
            const isOpen = clickedDropdown.classList.contains('open');

            dropdowns.forEach(dropdown => {
                dropdown.classList.remove('open');
                dropdown.closest('.collection-grid__form').classList.remove('filter-selected');
            });

            if (!isOpen) {
                clickedDropdown.classList.add('open');
                clickedDropdown.closest('.collection-grid__form').classList.add('filter-selected');
            }
        };

        const handleDocumentClick = (event) => {
            if (!event.target.closest('.collection-grid__filter-box-content') && !event.target.closest('.collection-grid__filter-box-title')) {
                dropdowns.forEach(dropdown => {
                    dropdown.classList.remove('open');
                    dropdown.closest('.collection-grid__form').classList.remove('filter-selected');
                });
            }
        };

        dropdowns.forEach(dropdown => {
            const title = dropdown.querySelector('.collection-grid__filter-box-title');
            title.addEventListener('click', handleDropdownClick);
        });

        document.addEventListener('click', handleDocumentClick);
    }


    resetClick(event) {
        event.preventDefault();
        const url = `${window.location.pathname}`;
        this.renderPage(url, '');
    }

    getParamsFromForm(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    initRender(event) {
        event.preventDefault();
        const searchParams = this.getParamsFromForm(this.form);
        const url = `${window.location.pathname}?${searchParams}`;
        this.renderPage(url, searchParams).then(r => {});
    }

    inputChange(event) {
        this.initRender(event)
    }

    async renderPage(url, searchParams) {
        disableLoadMoreScroll();
        if (window.innerWidth > 1024) {
            await window.scrollTo(0, 600);
        }
        enableLoadMoreScroll();
        this.grid.classList.add(this.classes.loadWrapper);

        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                this.grid.classList.remove(this.classes.loadWrapper);
                const html = responseText;
                this.updateURLHash(searchParams);
                this.renderGrid(html);
                this.renderFilter(html);
                initResetButtons();
            });
    }

    renderFilter(html) {
        this.filterDesktop.innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('#FilterDesktop').innerHTML;

        this.counters.forEach((counter, index) => {
            counter.innerHTML = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelectorAll('.js-collection-filter-counter')[index].innerHTML
        })

        this.boxes.forEach((box, index) => {
            box.innerHTML = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelectorAll('.js-collection-filter-box')[index].innerHTML
        })

        this.filterPopupButton.innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.js-collection-filter-popup-button').innerHTML;

        this.range = this.querySelector('.js-collection-range');
        this.rangeMin = this.querySelector('.js-collection-filter-price-range-min');
        this.rangeMax = this.querySelector('.js-collection-filter-price-range-max');
        this.inputs = this.querySelectorAll('.js-collection-filter-input');

        this.initRange();

        this.inputs.forEach(input => {
            input.addEventListener('change', this.inputChange.bind(this));
        });
    }

    renderGrid(html) {
        this.grid.innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('.js-collection-filter-grid').innerHTML;
    }

    updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    initRange() {
        if (!this.range) {
            return
        }

        let isElement = false;

        rangeSlider(this.range, {
            min: Math.round(this.range.dataset.min),
            max: Math.round(this.range.dataset.max),
            value: [Math.round(this.range.dataset.valueMin), Math.round(this.range.dataset.valueMax)],
            onInput: (valueSet) => {
                this.rangeMin.value = valueSet[0] + '.00';
                this.rangeMax.value = valueSet[1] + '.00';
            }
        });

        this.range.addEventListener('mousedown', (event) => {
            isElement = true
        })

        window.addEventListener('mouseup', (event)=> {
            if (isElement) {
                this.initRender(event);
                isElement = false;
            }
        })

        this.range.addEventListener('touchstart', (event) => {
            isElement = true
        })

        window.addEventListener('touchend', (event) => {
            if (isElement) {
                this.initRender(event);
                isElement = false;
            }
        })

        this.rangeMin.addEventListener('change', (event) => {
            this.initRender(event);
        })

        this.rangeMax.addEventListener('change', (event) => {
            this.initRender(event);
        })
    }
}

customElements.define('collection-filter', CollectionFilter);

class CollectionPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this.querySelector('.js-collection-filter-popup');
        this.popupContent = this.querySelector('.js-collection-filter-popup-content');
        this.popupToggles = document.querySelectorAll('.js-collection-filter-popup-toggle');

        this.classes = {
            popupOpen: "collection-grid__filter-popup--open"
        }

        this.popupToggles.forEach(popupToggle => {
            popupToggle.addEventListener('click', this.popupToggleClick.bind(this))
        })
    }

    popupToggleClick(e) {
        e.preventDefault()
        this.popup.classList.contains(this.classes.popupOpen) ? this.closePopup() : this.openPopup()
    }

    openPopup() {
        this.popup.classList.add(this.classes.popupOpen)
        bodyScrollLock.disableBodyScroll(this.popupContent)
    }

    closePopup() {
        this.popup.classList.remove(this.classes.popupOpen)
        bodyScrollLock.clearAllBodyScrollLocks()
    }
}

customElements.define('collection-popup', CollectionPopup);

function initResetButtons() {
    let resets = document.querySelectorAll('.js-collection-filter-reset');

    resets.forEach(reset => {
        let filter = reset.closest('collection-filter')
        reset.addEventListener('click', function (e) {
            filter.resetClick(e)
        });
    });
}

function disableLoadMoreScroll() {
    this.loadMore = document.querySelector('.js-load-more');
    this.loadMore.isLoading = true;
}

function enableLoadMoreScroll() {
    this.loadMore = document.querySelector('.js-load-more');
    this.loadMore.isLoading = true;
}
